// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"79b4ba91","464":"7100477e","588":"7fe97b64","694":"99e18412","709":"3f38f0e2","903":"f4a91bdb"}[chunkId] + ".chunk.js";
};